import { Flex } from "Element/Flex";
import styled from "styled-components";

export const StyledHowContainer = styled.div`
  height: fit-content;
  padding: 180px 72px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: auto;
    padding: 120px 24px;
  `}
`;

export const StyledHowWrapper = styled(Flex)`
  height: 100%;
  h1 {
    margin-bottom: 96px;
  }
  div {
    :not(:last-child) {
      margin-bottom: 36px;
    }
  }
  img {
    margin-bottom: 24px;
  }
  ${({ theme }) => theme.mediaWidth.upToLarge`
    height: auto;
  `}
`;

export const StyledStepsWrapper = styled(Flex)`
  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-content: center;
  `}
`;

export const StepImg = styled.img`
  margin: 0 auto;
  width: 147px;
  margin-bottom: 24px;
`;
